import { DoughnutChart, DoughnutChartLegend } from '@/components/charts/DoughnutChart';
import { MatchedGrantsSelectors } from '@/store/matchedGrants';
import { Box, Grid2, Typography, useTheme } from '@mui/material';
import { ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip, } from 'chart.js';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
ChartJS.register(Title, Tooltip, Legend, CategoryScale, LinearScale, ArcElement);
export const PotentialFundingGraph = () => {
    const theme = useTheme();
    const chartRef = useRef(null);
    const matchedGrants = useSelector(MatchedGrantsSelectors.makeGrantDataForDoughnut);
    return (React.createElement(Box, { sx: { flex: '1 1 auto', minHeight: '400px', maxWidth: '100%' } },
        React.createElement(Typography, { variant: "h5", sx: { fontWeight: theme.typography.fontWeightSemiBold, fontSize: '1rem', m: '0.5rem' } }, "Potential Funding"),
        React.createElement(Box, { sx: {
                borderRadius: theme.shape.borderRadius * 2,
                backgroundColor: theme.palette.grey[100],
                padding: '4px',
            } },
            React.createElement(Grid2, { container: true, spacing: 0, direction: "row" },
                React.createElement(Grid2, { size: { sm: 12, md: 4 } },
                    React.createElement(DoughnutChart, { data: matchedGrants, ref: chartRef, containerProps: {
                            sx: { flex: '0 1 25%' },
                        }, options: {
                            elements: {
                                arc: {
                                    borderWidth: 0,
                                },
                            },
                            layout: {
                                padding: {
                                    left: 8,
                                    right: 8,
                                    top: 0,
                                    bottom: 0,
                                },
                            },
                        } })),
                React.createElement(Grid2, { size: { sm: 12, md: 8 }, sx: { padding: '8px' } },
                    React.createElement(DoughnutChartLegend, { chartRef: chartRef }))))));
};
